if( ! document.getElementById('filter-job-typing') ) {
    return;
}

document.getElementById('filter-job-typing').addEventListener('keyup', function () {
    const filterQuery = this.value.trim();
    const autocompleteBox = document.getElementById('filter-job-autocomplete');

    if (filterQuery.length > 1) {
        const jobFilterFetchUrl = ajax_callback_data.ajax_url + '?action=filter_jobs&search=' + encodeURIComponent(filterQuery);
        fetch(jobFilterFetchUrl)
            .then(response => response.json())
            .then(data => {
                if (data.length > 0) {
                    autocompleteBox.innerHTML = `<div class="filter-autocomplete">
                        ${data
                            .map(item => `<div class="autocomplete-item" data-title="${item}">${item}</div>`)
                            .join('')}
                    </div>`;
                    autocompleteBox.style.display = 'block';

                    // Attach click event to newly added items
                    document.querySelectorAll('.autocomplete-item').forEach(item => {
                        item.addEventListener('click', function () {
                            document.getElementById('filter-job-typing').value = this.dataset.title;
                            autocompleteBox.style.display = 'none';
                        });
                    });
                } else {
                    autocompleteBox.innerHTML = '<div class="filter-autocomplete no-results">No results found</div>';
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    } else {
        autocompleteBox.style.display = 'none';
    }
});

// Hide autocomplete when clicking outside
document.addEventListener('click', function (e) {
    const inputBox = document.getElementById('filter-job-typing');
    const autocompleteBox = document.getElementById('filter-job-autocomplete');
    
    if (!inputBox.contains(e.target) && !autocompleteBox.contains(e.target)) {
        autocompleteBox.style.display = 'none';
    }
});